import React, { useEffect, useState } from "react";
import api, { GetToken } from "../../api/axios";
import { Navigate, useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import Loading from "../../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faClipboardCheck, faMoneyBill1Wave } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

export default function List() {

  const { id } = useParams();
  //const [role, setRole] = useState();
  const [loading, setLoading] = useState(false);
  const [getList, setGetList] = useState([]);

  useEffect( () => {
    const events = new EventSource(`https://webhook.brix.app.br/events/?id=${id}`);

    events.onmessage = (event) => {
      const parsedData = JSON.parse(event.data);

      switch (parsedData?.event) {
        case "OPPENED":
        case "PIX_SUCCESSFUL":
          break;
        case "PIX_PAID":
          checkPayment(id);
          events.close();
          break;
        case "PIX_CREATED":
        case "PIX_FAILED":
        case "PIX_PAYMENT_REFUNDED":
        case "PIX_REFUNDED":
        case "PIX_EXPIRED":
        case "PIX_EXPIRED_WITHOUT_PAYMENT":
        case "PIX_BANK_REJECTED":
        case "PIX_USER_REMOVED":
        case "BANK_WEBHOOK_RECEIVED":
        case "PIX_QRCODE_OPENED":
        case "PAYMENT_PROCESSING":
        case "PAYMENT_FAILED":
        case "PAYMENT_UPDATED":
        default:
          console.log("SSE Event:", parsedData);
      }
    };

    return () => {
      if (events.readyState !== events.CLOSED) {
        events.close();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {

    const token = GetToken();
    if (token === "null") {
      return <Navigate to="/" />;
    }

    if (!token) {
      return <Navigate to="/" />;
    }

    var userInfo = {};
    try {
      userInfo = jwt_decode(token);
      //setRole(userInfo.role);
    } catch (error) {
      console.log('👾 invalid token format', error);
      return true;
    }

    if (!id) {
      return <Navigate to="/dashboard" />;
    }

    if (userInfo.chgpss === 1) {
      return null;
    }

    UpdateList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function UpdateList() {
    setLoading(true);
    
    api.get('/v1/charge/getbytxid/' + id, 
      { headers: { "x-access-token": GetToken() }
    })
      .then(getlist => {
        if (!getlist.data.res) {
        } else {
          setGetList(getlist.data.message);
        }
      }).catch(_ => {
        console.log(_);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleClick(item) {
    const newList = getList.map((qrcode) => {
      if (qrcode.id === item.id) {
        return {
          ...qrcode,
          isBlur: !qrcode.isBlur
        };
      } else {
        return qrcode;
      }
    });
    setGetList(newList);
  }

  function handleCopy(item) {
    var newList = getList.map((qrcode) => {
      if (qrcode.id === item.id) {
        return {
          ...qrcode,
          isCopied: !qrcode.isCopied
        };
      } else {
        return qrcode;
      }
    });

    setGetList(newList);

    //navigator.clipboard.write(item.qrcode);
    copyToClipboard(item.qrcode);

    setTimeout(() => {
      newList = getList.map((qrcode) => {
        if (qrcode.id === item.id) {
          return {
            ...qrcode,
            isCopied: qrcode.isCopied
          };
        } else {
          return qrcode;
        }
      });
      setGetList(newList);
    }, 2000);
  }

  function copyToClipboard(str) {
    var el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style = {position: 'absolute', left: '-9999px'};
    document.body.appendChild(el);

    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        // save current contentEditable/readOnly status
        var editable = el.contentEditable;
        var readOnly = el.readOnly;

        // convert to editable with readonly to stop iOS keyboard opening
        el.contentEditable = true;
        el.readOnly = true;

        // create a selectable range
        var range = document.createRange();
        range.selectNodeContents(el);

        // select the range
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        el.setSelectionRange(0, 999999);

        // restore contentEditable/readOnly to original state
        el.contentEditable = editable;
        el.readOnly = readOnly;
    } else {
        el.select(); 
    }

    document.execCommand('copy');
    document.body.removeChild(el);
  }

  function checkPayment(txid) {
    setLoading(true);
    
    api.get('/v1/charge/check/' + txid, 
      { headers: { "x-access-token": GetToken() }
    })
      .then(getcheck => {
        console.log(getcheck.data.message);
        if (!getcheck.data.res) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: JSON.stringify(getcheck),
          });
        } /*else {
          Swal.fire({
            icon: "success",
            title: "Sucesso",
            text: "Seu PIX foi criado com sucesso!",
          }).then(() => {
            const cod = getcheck.data.txid
            history("/dashboard/pix/" + cod);
          });
        }*/
        UpdateList();
      }).catch(error => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: JSON.stringify(error),
        });
        console.log(error);
      })
      .finally(() => { 
        setLoading(false);
      });
  }

  function QRCode({ items, onClick, onCopy }) {
    return (
      <div className="d-flex flex-wrap col-md-12 col-12">
        {items.map((item) => (
          <div className="card text-white bg-secondary" style={{width: "20rem", margin: "10px"}} key={item.id}>
            <div className="card-header text-center">
              {item.status === "CONCLUIDA" ? "PAGO" : item.status === "EXPIRADA" ? "EXPIRADO" : "AGUARDANDO PAGAMENTO"}
            </div>
            <div className={ "card-body text-center "  + (item.status === "EXPIRADA" ? "bg-light text-muted" : item.status !== "CONCLUIDA"  ? "bg-warning text-muted" : "bg-success text-white") }>
              {!item.qrcodeimage ? <p>Sem Imagem</p> :
                <img className="card-img-top" src={ !item.qrcodeimage ? "" : "data:image/png;base64," + item.qrcodeimage } style={{ filter: item.status === "EXPIRADA" ? "blur(4px)" : item?.isBlur ? "blur(0px)" : "blur(4px)"}} type="button" onClick={() => item.status !== "EXPIRADA" && onClick(item)} alt="QR Code" />
              }
              <span>{ item.status === "EXPIRADA" ? "QRCode expirado" : item?.isBlur ? "Clique para borrar" : "Clique para aparecer" }</span>
            </div>
            <div className="card-footer">
              <p className="card-text">
                Data: {item.creation}<br />
                Valor: {parseFloat(item.amount).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}<br />
                { item.sellorder ? (<span>Descrição: {item.sellorder} <br /></span>) : null}
                { item.payerinfo ? (<span>Mensagem: {item.payerinfo} <br /></span>) : null}
                { item.personname ? (<span>Devedor: {item.personname} <br /></span>) : null}
                { item.persontype ? (<span>{item.persontype}: {item.personnumber}</span>) : null}
              </p>
              <div className="d-flex justify-content-between card-text">
                <button type="submit"
                  className={"btn btn-sm ".concat(item?.isCopied ? "bg-white" : "bg-white")}
                  onClick={ () => checkPayment(item.txid) }
                >
                  <FontAwesomeIcon id="clipboard" icon={ faMoneyBill1Wave } size="lg" className="btn-icon mr-4" />Verificar
                </button>
                <button type="submit" 
                  className={"btn btn-sm ".concat(item?.isCopied ? "bg-white" : "bg-white")}
                  onClick={() => onCopy(item, this)}
                >
                  <FontAwesomeIcon id="clipboard" icon={ item?.isCopied ? faClipboardCheck : faCopy } size="lg" className="btn-icon mr-4" />{ item?.isCopied ? "Copiado!" : "Copiar" }
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  //CORES
  //#0000BF #3F7F00 #82FF05 #FBE731 #F60404"
  return (
    <div>
      <Loading visible={loading} />
      <div className="row">
        <QRCode items={getList} onClick={ handleClick } onCopy={ handleCopy } />
      </div>
    </div>
  );
}